import { Subscription } from 'rxjs';
import { LyDialog } from '@alyle/ui/dialog';
import { ImgCropperEvent } from '@alyle/ui/image-cropper';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ProfissionalService } from '../services/rh/profissional.service';
import { AuthService } from '../services/vos/auth.service';
import { CropperDialogComponent } from './cropper-dialog/cropper-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-meu-perfil',
  templateUrl: './meu-perfil.component.html',
  styleUrls: ['./meu-perfil.component.css']
})
export class MeuPerfilComponent implements OnInit {
  formulario!: FormGroup;
  isTextFieldType1: boolean = true;
  isTextFieldType2: boolean = true;
  isTextFieldType3: boolean = true;
  dados = {
    email: "",
    password: "",
    newPassword: ""
  }
  usuario: any = []
  cropped?: string;
  token: any = []
  selectedSection = 1
  sectionSelect = document.getElementById("selectedValue")
  inscricao: Subscription;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private profissionalService: ProfissionalService,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.pegarUsuario();
    this.formulario = this.formBuilder.group({
      password: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required]
    });
    this.sectionSelect.addEventListener('change', ()=>{
    this.sectionSwitch(this.selectedSection)
});
  console.log(this.usuario)
  }

  pegarUsuario() {
    this.token = JSON.parse(this.authService.getUserLoggedIn())
    this.inscricao = this.profissionalService.meuperfil().subscribe(res => {
      this.usuario = res;
    })
  }

  openCropperDialog(event: Event) {
    this.cropped = null!;
    this._dialog.open<CropperDialogComponent, Event>(CropperDialogComponent, {
      data: event,
      width: 320,
      disableClose: true
    }).afterClosed.subscribe((result?: ImgCropperEvent) => {
      if (result) {

        this.salvarImagemPerfil(result.dataURL)

      }
    });
  }

  salvarImagemPerfil(data) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false,
    })

    swalWithBootstrapButtons.fire({
      title: 'Salvar imagem?',
      text: 'Você está alterando a foto do perfil!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, salvar!',
      cancelButtonText: 'Não, cancelar!',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.cropped = data;
        this.token.user.pessoa.perfil = data
        this._cd.markForCheck();
        this.inscricao = this.profissionalService.atualizarFotoPerfil(this.token).subscribe(res => {
          Swal.fire("Salvo!", "Salvo com sucesso!", "success");
        })
      } else {
        swalWithBootstrapButtons.fire('Cancelado', 'Item não salvo! :)', 'error')
        this.cropped = null!
      }
    });
  }

  ngOnDestroy() {
    if(this.inscricao) this.inscricao.unsubscribe();
  }

  sectionSwitch(x: number){
    this.selectedSection = x
  }

  async alterarSenha() {
    let dados = {
      password: this.formulario.value.password,
      newPassword: this.formulario.value.newPassword,
      email: this.token.user.email
    }

    this.inscricao = this.authService.alterarSenha(this.token, dados).subscribe(res => {
      this.formulario.reset();
      Swal.fire("Alterado!", "Sua senha foi alterada com sucesso...", "success")
    },
    error => {
      Swal.fire("Ops!", "Um erro ocorreu!", "error")
    });
  }

}
